import Text from '../../components/common/Text'
import Breadcrumb from '../../components/common/Breadcrumb'
import { mobile } from '../../utils/responsive-helper'
import styled from '@emotion/styled'
import { eClaimList, enrollment, home } from '../../constant/path'
import { useGetEClaimList } from '../../services/e-claim/e-claim-query'
// import { eClaimHistoryDetail } from '../../constant/path'
import { EClaimListItem } from '../../services/e-claim/e-claim-types'
import Card from '../../components/common/Card'
import Image from '../../components/common/Image'
import { numberWithCommas } from '../../utils/helper'
import iconNews from '../../assets/images/icon-news.png'

// import { Link } from 'react-router-dom'

const FlexRow = styled.div`
  display: flex;
  ${mobile} {
    flex-direction: column;
  }
`
const FlexRowPoint = styled.div`
  display: flex;
  justify-content: flex-end;
`
const CardContainer = styled(Card)`
  margin: 24px;
  padding: 24px;
  display: flex;
  ${mobile} {
    margin: 10px;
    padding: 5px;
  }
`

const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 32px;
`

const BreadcrumbContainer = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;
`
const ImageStyle = styled(Image)`
  margin: 10px;
  margintop: 0px;
  ${mobile} {
    align-self: center;
  }
`

const EClaimList = () => {
  const { data: eclaimList } = useGetEClaimList()

  return (
    <div>
      <BreadcrumbContainer>
        <Breadcrumb
          overide={(paths) => {
            paths[0] = {
              label: 'Home',
              path: home(),
            }
            paths[1] = {
              label: 'ปรับเปลี่ยนสวัสดิการ',
              path: enrollment(),
            }
            paths[2] = {
              label: 'สวัสดิการเพื่อไลฟ์สไตล์',
              path: eClaimList(),
            }
            return paths
          }}
        />
      </BreadcrumbContainer>
      <TitleContainer>
        <Text type="Bold" size={32}>
          สวัสดิการเพื่อไลฟ์สไตล์
        </Text>
      </TitleContainer>
      {eclaimList?.map((item: EClaimListItem, index) => {
        const labelUseCoin = `${numberWithCommas(item.maxClaimablePrice || 0)}`
        const availableAmountText = ` ${numberWithCommas(item.availableAmount || 0)} คะแนน)`
        const mainIcons = item?.claimIcon ? item?.claimIcon : iconNews

        return (
          // <Link
          //   key={`${index}-${item.claimId}-${item.claimName}`}
          //   to={eClaimHistoryDetail({
          //     routeParam: {
          //       id: item.claimId,
          //     },
          //   })}
          // >
          <CardContainer >
            <ImageStyle src={mainIcons} width={40} height={40} />
            <Text size={20} type={'Bold'} color="#005da7" style={{ marginRight: 'auto' }}>
              {item.claimName}
            </Text>
            <div style={{ textAlign: 'end', whiteSpace: 'nowrap' }}>
              <FlexRowPoint>
                <Text size={15} className="lable-use-coin" maxLine={1} type="Bold" color="#005da7">
                  {labelUseCoin}
                </Text>
                <Text size={15} className="lable-use-coin" maxLine={1} type="Medium">
                  คะแนน
                </Text>
              </FlexRowPoint>
              <FlexRow>
                <Text size={15} maxLine={1} type={'Medium'} style={{ paddingRight: '3px' }}>
                  (คงเหลือ
                </Text>
                <Text size={15} maxLine={1} type={'Medium'}>
                  {availableAmountText}
                </Text>
              </FlexRow>
            </div>
          </CardContainer>
          // </Link>
        )
      })}
    </div>
  )
}

export default EClaimList
